<template>
    <!-- company-info-view .civ -->
    <div class="civ">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>首页</BreadcrumbItem>
                    <BreadcrumbItem>设置</BreadcrumbItem>
                    <BreadcrumbItem>表单设置</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">表单设置</div>
                <!-- <p style="line-height:40px;color:#808080;font-size:12px;">展会相关的基础数据设置</p> -->
            </div>
            <div class="header-tool-box" v-if="String(showTabs) === '2'&&indexShow2">
                <div class="htb-item" @click="handleClick2" >
                    <span>+添加</span>
                </div>
            </div>
            <div class="header-tool-box" v-if="String(showTabs) === '2'&&indexShow3">
                <div class="htb-item" @click="handleClick3" >
                    <span>+添加</span>
                </div>
            </div>
            <div class="header-tool-box" v-if="String(showTabs) === '8'&&indexShow8">
                <div class="htb-item" @click="handleClick8" >
                    <span>+添加</span>
                </div>
            </div>
            <div class="header-tool-box" v-if="String(showTabs) === '9'&&indexShow9">
                <div class="htb-item" @click="handleClick9" >
                    <span>+添加</span>
                </div>
            </div>
            <div class="header-tool-box" v-if="String(showTabs) === '10'">
                <div class="htb-item" @click="handleClick10" >
                    <span>+添加</span>
                </div>
            </div>
          
        </div>
        <div class="header-tabs">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">

                <TabPane label="会刊免费登记表" name="1">
                    <comm1 ref="hostSetSupply" v-if="String(showTabs) === '1'" />
                </TabPane>
                <TabPane label="参展展品信息申报表" name="2">
                    <comm2 ref="child2" v-if="String(showTabs) === '2'" @fatherMethod2="fatherMethod2"  />
                </TabPane>
                <TabPane label="展位楣板信息登记表" name="3">
                    <comm3 ref="hostSetSupply" v-if="String(showTabs) === '3'" />
                </TabPane>
                <TabPane label="参展商胸卡信息登记表" name="4">
                    <comm4 ref="hostSetSupply" v-if="String(showTabs) === '4'" />
                </TabPane>
                <TabPane label="会刊广告征订表" name="5">
                    <comm5 ref="hostSetSupply" v-if="String(showTabs) === '5'" />
                </TabPane>
                <TabPane label="现场广告征订表" name="6">
                    <comm6 ref="hostSetSupply" v-if="String(showTabs) === '6'" />
                </TabPane>
                <TabPane label="标准展台搭建变更申请表" name="7">
                    <comm7 ref="hostSetSupply" v-if="String(showTabs) === '7'" />
                </TabPane>
                <TabPane label="增租家具及电信服务一览表" name="8">
                    <comm8 ref="child8" v-if="String(showTabs) === '8'" @fatherMethod8="fatherMethod8" />
                </TabPane>
                <TabPane label="展台现场拆除&安装施工价目表" name="9">
                    <comm9 ref="child9" v-if="String(showTabs) === '9'" @fatherMethod9="fatherMethod9" />
                </TabPane>
                <!-- <TabPane label="回执表管理" name="10">
                    <comm10 ref="child10" v-if="String(showTabs) === '10'" />
                </TabPane> -->

            </Tabs>
        </div>
    </div>
</template>
  
<script>
import comm1 from "../components/com_1.vue";
import comm2 from "../components/com_2.vue";
import comm3 from "../components/com_3.vue";
import comm4 from "../components/com_4.vue";
import comm5 from "../components/com_5.vue";
import comm6 from "../components/com_6.vue";
import comm7 from "../components/com_7.vue";
import comm8 from "../components/com_8.vue";
import comm9 from "../components/com_9.vue";
import comm10 from "../components/com_10.vue";


export default {
    name: "host-set",
    data () {
        return {
            showTabs: "1",
            show: false,
            indexShow2: false,
            indexShow3: false, //这是参展展品信息  下面的第三个tab参数
            indexShow8: false,
            indexShow9: false,
        };
    },
    components: {
        comm1,
        comm2,
        comm3,
        comm4,
        comm5,
        comm6,
        comm7,
        comm8,
        comm9,
        comm10,

    },
    created () {
        this.changeTab();
    },
    methods: {
        changeTab () {
            let query = this.$route.query;
            if (query && query.type && query.type === "supply") {
                this.showTabs = "1";
            }
        },
        switchBrand (index) {
        
        },
        showAdd (name) {
            this.$refs[name].showAdd();
        },
        // 组件  参展展品信息调用的方法
        fatherMethod2(data1,data2){
            this.indexShow2=data1
            this.indexShow3=data2
        },
        handleClick2(){
            this.$refs.child2.addClick()
        },
        handleClick3(){
            this.$refs.child2.addClick2()
        },

        fatherMethod8(data1){
            this.indexShow8=data1
        },
        handleClick8(){
            this.$refs.child8.addClick()
        },
        fatherMethod9(data1){
            this.indexShow9=data1
        },
        handleClick9(){
            this.$refs.child9.addClick()
        },
        handleClick10(){
            this.$refs.child10.addClick()
        },

    }
};
</script>
  
<style scoped lang="scss">
.civ {
    .header-tool {
        padding: 18px 25px 0 35px;
    }
}
</style>
  